import Vue from 'vue';
import { apiPath } from '@/api/constants';

export default Vue.resource(
  `${apiPath}/account/sms{/action}/`,
  {},
  {
    sendSMS: { method: 'POST', params: { action: 'send' } },
    verifyCode: { method: 'POST', params: { action: 'verify' } },
  },
);
